export default __webpack_public_path__ + "static/media/bg45.0c9a1d6c.jpg";